import { getLanguageLabel, normalizeLanguageCode } from "@/config/languages.js";

export const AFRIMED_MARKETS = [
  {
    iso: "ao",
    name: "Angola",
    group: "sadc",
    dialCode: "+244",
    flag: "ao",
    defaultLanguage: "pt",
    supportedLanguages: ["pt", "en-GB"],
  },
  {
    iso: "bw",
    name: "Botswana",
    group: "sadc",
    dialCode: "+267",
    flag: "bw",
    defaultLanguage: "tn",
    supportedLanguages: ["tn", "en-GB"],
  },
  {
    iso: "cd",
    name: "DR Congo",
    group: "sadc",
    dialCode: "+243",
    flag: "cd",
    defaultLanguage: "fr",
    supportedLanguages: ["fr", "en-GB"],
  },
  {
    iso: "sz",
    name: "Eswatini",
    group: "sadc",
    dialCode: "+268",
    flag: "sz",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "zu"],
  },
  {
    iso: "ls",
    name: "Lesotho",
    group: "sadc",
    dialCode: "+266",
    flag: "ls",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "mw",
    name: "Malawi",
    group: "sadc",
    dialCode: "+265",
    flag: "mw",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "ny"],
  },
  {
    iso: "mg",
    name: "Madagascar",
    group: "sadc",
    dialCode: "+261",
    flag: "mg",
    defaultLanguage: "fr",
    supportedLanguages: ["fr", "en-GB"],
  },
  {
    iso: "mu",
    name: "Mauritius",
    group: "sadc",
    dialCode: "+230",
    flag: "mu",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr"],
  },
  {
    iso: "mz",
    name: "Mozambique",
    group: "sadc",
    dialCode: "+258",
    flag: "mz",
    defaultLanguage: "pt",
    supportedLanguages: ["pt", "en-GB"],
  },
  {
    iso: "na",
    name: "Namibia",
    group: "sadc",
    dialCode: "+264",
    flag: "na",
    defaultLanguage: "de",
    supportedLanguages: ["de", "en-GB", "af"],
  },
  {
    iso: "sc",
    name: "Seychelles",
    group: "sadc",
    dialCode: "+248",
    flag: "sc",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr"],
  },
  {
    iso: "za",
    name: "South Africa",
    group: "sadc",
    dialCode: "+27",
    flag: "za",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "zu", "xh", "af"],
  },
  {
    iso: "tz",
    name: "Tanzania",
    group: "sadc",
    dialCode: "+255",
    flag: "tz",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "zm",
    name: "Zambia",
    group: "sadc",
    dialCode: "+260",
    flag: "zm",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "bem", "ny"],
  },
  {
    iso: "zw",
    name: "Zimbabwe",
    group: "sadc",
    dialCode: "+263",
    flag: "zw",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "sn", "nd"],
  },
  {
    iso: "cm",
    name: "Cameroon",
    group: "africa",
    dialCode: "+237",
    flag: "cm",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr"],
  },
  {
    iso: "gh",
    name: "Ghana",
    group: "africa",
    dialCode: "+233",
    flag: "gh",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "ke",
    name: "Kenya",
    group: "africa",
    dialCode: "+254",
    flag: "ke",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "ng",
    name: "Nigeria",
    group: "africa",
    dialCode: "+234",
    flag: "ng",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "rw",
    name: "Rwanda",
    group: "africa",
    dialCode: "+250",
    flag: "rw",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr"],
  },
  {
    iso: "ug",
    name: "Uganda",
    group: "africa",
    dialCode: "+256",
    flag: "ug",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "at",
    name: "Austria",
    group: "diaspora",
    dialCode: "+43",
    flag: "at",
    defaultLanguage: "de",
    supportedLanguages: ["de", "en-GB"],
  },
  {
    iso: "au",
    name: "Australia",
    group: "diaspora",
    dialCode: "+61",
    flag: "au",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "be",
    name: "Belgium",
    group: "diaspora",
    dialCode: "+32",
    flag: "be",
    defaultLanguage: "fr",
    supportedLanguages: ["fr", "de", "en-GB"],
  },
  {
    iso: "ca",
    name: "Canada",
    group: "diaspora",
    dialCode: "+1",
    flag: "ca",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr-CA"],
  },
  {
    iso: "de",
    name: "Germany",
    group: "diaspora",
    dialCode: "+49",
    flag: "de",
    defaultLanguage: "de",
    supportedLanguages: ["de", "en-GB"],
  },
  {
    iso: "fr",
    name: "France",
    group: "diaspora",
    dialCode: "+33",
    flag: "fr",
    defaultLanguage: "fr",
    supportedLanguages: ["fr", "en-GB"],
  },
  {
    iso: "nz",
    name: "New Zealand",
    group: "diaspora",
    dialCode: "+64",
    flag: "nz",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "ch",
    name: "Switzerland",
    group: "diaspora",
    dialCode: "+41",
    flag: "ch",
    defaultLanguage: "de",
    supportedLanguages: ["de", "fr-CH", "en-GB"],
  },
  {
    iso: "ae",
    name: "United Arab Emirates",
    group: "diaspora",
    dialCode: "+971",
    flag: "ae",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr"],
  },
  {
    iso: "gb",
    name: "United Kingdom",
    group: "diaspora",
    dialCode: "+44",
    flag: "gb",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB"],
  },
  {
    iso: "us",
    name: "United States",
    group: "diaspora",
    dialCode: "+1",
    flag: "us",
    defaultLanguage: "en-GB",
    supportedLanguages: ["en-GB", "fr", "pt"],
  },
];

export const COUNTRY_STORAGE_KEY = "afrimed.country";
export const COUNTRY_CHANGE_EVENT = "afrimed-country-change";

function normalizeIso(iso) {
  return String(iso || "")
    .trim()
    .toLowerCase();
}

export const SADC_MARKETS = AFRIMED_MARKETS.filter(
  (market) => market.group === "sadc"
);
export const AFRICA_MARKETS = AFRIMED_MARKETS.filter(
  (market) => market.group === "africa"
);
export const DIASPORA_MARKETS = AFRIMED_MARKETS.filter(
  (market) => market.group === "diaspora"
);
export const MARKET_GROUP_LABELS = {
  sadc: "SADC Markets",
  africa: "Other African Markets",
  diaspora: "Diaspora Markets",
};

export function getMarketByIso(iso) {
  const normalized = normalizeIso(iso);
  return AFRIMED_MARKETS.find((market) => market.iso === normalized) || null;
}

export function getMarketByDialCode(dialCode) {
  return (
    AFRIMED_MARKETS.find(
      (market) => String(market.dialCode || "").trim() === String(dialCode || "").trim()
    ) || null
  );
}

export function getMarketCountryNames() {
  return AFRIMED_MARKETS.map((market) => market.name);
}

export function getGroupedMarketCountryNames() {
  return [
    {
      key: "sadc",
      label: MARKET_GROUP_LABELS.sadc,
      countries: SADC_MARKETS.map((market) => market.name),
    },
    {
      key: "africa",
      label: MARKET_GROUP_LABELS.africa,
      countries: AFRICA_MARKETS.map((market) => market.name),
    },
    {
      key: "diaspora",
      label: MARKET_GROUP_LABELS.diaspora,
      countries: DIASPORA_MARKETS.map((market) => market.name),
    },
  ];
}

export function buildMarketLanguageSummary(market) {
  const codes = Array.isArray(market?.supportedLanguages)
    ? market.supportedLanguages
    : [market?.defaultLanguage].filter(Boolean);

  const labels = Array.from(
    new Set(
      codes
        .map((code) => normalizeLanguageCode(code))
        .map((code) => getLanguageLabel(code))
        .filter(Boolean)
    )
  );

  return labels.join(" / ");
}

export function getCountryLanguageOptions() {
  return AFRIMED_MARKETS.map((market) => ({
    ...market,
    label: `${market.name} - ${buildMarketLanguageSummary(market)}`,
    lang: market.defaultLanguage,
  }));
}

export function getInitialMarketIso() {
  if (typeof window === "undefined") return "za";

  try {
    const stored = window.localStorage.getItem(COUNTRY_STORAGE_KEY);
    const market = getMarketByIso(stored);
    return market?.iso || "za";
  } catch {
    return "za";
  }
}

export function setMarketPreference(iso) {
  const market = getMarketByIso(iso) || getMarketByIso("za");
  const normalizedIso = market?.iso || "za";

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(COUNTRY_STORAGE_KEY, normalizedIso);
      window.dispatchEvent(
        new CustomEvent(COUNTRY_CHANGE_EVENT, {
          detail: { iso: normalizedIso },
        })
      );
    } catch {
      // no-op
    }
  }

  return normalizedIso;
}

export function getMarketLanguageNames(iso) {
  const market = getMarketByIso(iso);
  const codes = Array.isArray(market?.supportedLanguages)
    ? market.supportedLanguages
    : [market?.defaultLanguage].filter(Boolean);

  return Array.from(
    new Set(
      codes
        .map((code) => normalizeLanguageCode(code))
        .map((code) => {
          switch (code) {
            case "en-GB":
              return "English";
            case "pt":
              return "Portuguese";
            case "fr":
            case "fr-CH":
            case "fr-CA":
              return "French";
            case "de":
              return "German";
            case "tn":
              return "Setswana";
            case "zu":
              return "isiZulu";
            case "xh":
              return "isiXhosa";
            case "af":
              return "Afrikaans";
            case "sn":
              return "Shona";
            case "nd":
              return "isiNdebele";
            case "bem":
              return "Bemba";
            case "ny":
              return "Nyanja / Chichewa";
            default:
              return getLanguageLabel(code);
          }
        })
        .filter(Boolean)
    )
  );
}
